import { Select, Text, TextInput, Tooltip } from "@mantine/core";
import React from "react";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { tblInventoryTransaction } from "../../../../model/TblOutWard";
import RenderTable from "./RenderTable";
import { ComboboxItem } from "../../../../model/ComboboxItem";
import classesButton from "../../../../../src/Styles/StyleButton.module.css";

const RequestVendorReturnOutWard = ({
  dataSearchSourceCodeOption,
  dataOutWard,
  sourceCode,
  setSourceCode,
  handleKeyDownSourceCode,
  dataOrderDetail,
  handleChangeValueInput,
  isSave,
  setSearchSourceCode,
  isEdit,
  isLocked,
  haveSourceCode,
  action,
  dataBranch,
  updatedDataInventoryTransactionType,
}: RequestVendorReturnOutWardProps) => {
  const isDisabled =
    dataOutWard.status === "LOCK" ||
    sourceCode ||
    isSave ||
    ["DETAIL", "EDIT"].includes(action);
  const headers = [
    { label: "", style: { width: "25%" } },
    { label: "Bên xuất", style: { width: "25%" } },
    { label: "", style: { width: "25%" } },
    { label: "Bên nhận", style: { width: "25%" } },
  ];

  const getDeliveryText = (delivery: string) => {
    switch (delivery) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "NOI_BO":
      case "HA_COM":
        return "Nội bộ";
      default:
        return delivery;
    }
  };
  const rows = [
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian tạo
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOrderDetail?.createDate ?? "")}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Tên NCC
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian hoàn thành
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOutWard?.finishDate)}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã NCC
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {" "}
            {dataOrderDetail?.cusCode}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu xuất kho
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOutWard?.transactionCode}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Tỉnh/Thành
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusProvinceName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu yêu cầu xuất kho
          </Text>
        ),
      },
      {
        content:
          !isEdit && !haveSourceCode ? (
            <Tooltip
              label={
                dataOutWard?.sourceCode
                  ? dataOutWard?.sourceCode
                  : "Vui lòng chọn phiếu"
              }
            >
              <Select
                w={"160px"}
                placeholder="Mã phiếu yêu cầu xuất kho"
                data={dataSearchSourceCodeOption}
                size="sm"
                disabled={
                  !dataOutWard.sourceType ||
                  dataOutWard.status === "LOCK" ||
                  sourceCode ||
                  isSave
                }
                className={classesButton.text_input}
                searchable
                clearable
                onSearchChange={(e) => {
                  if (setSearchSourceCode) {
                    setSearchSourceCode(e);
                  }
                }}
                onKeyDown={handleKeyDownSourceCode}
                value={sourceCode || dataOutWard.sourceCode}
                onChange={(value) => {
                  if (handleChangeValueInput) {
                    handleChangeValueInput(value || "", "sourceCode");
                  }
                  if (setSourceCode) {
                    setSourceCode(value);
                  }
                }}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            </Tooltip>
          ) : (
            <Text
              w={"150px"}
              size="sm"
              style={{ whiteSpace: "normal" }}
              truncate
            >
              {dataOutWard.sourceCode}{" "}
            </Text>
          ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Quận/Huyện
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusDestrictName}
          </Text>
        ),
      },
    ],
    // [
    //   {
    //     content: (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         Lý do
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: !isDisabled ? (
    //       <Select
    //         searchable
    //         clearable
    //         w={160}
    //         className={classesButton.text_input}
    //         placeholder="Chọn lý do"
    //         disabled={
    //           dataOutWard.status === "LOCK" ||
    //           sourceCode ||
    //           isSave ||
    //           ["DETAIL", "EDIT"].includes(action)
    //         }
    //         data={updatedDataInventoryTransactionType}
    //         value={dataOutWard.sourceType?.toString() || ""}
    //         onChange={(value) => {
    //           handleChangeValueInput(value || "", "sourceType");
    //         }}
    //       />
    //     ) : (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         {
    //           updatedDataInventoryTransactionType?.find(
    //             (t) => t.value === dataOutWard.sourceType?.toString()
    //           )?.label
    //         }
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: null,
    //   },
    //   {
    //     content: null,
    //   },
    // ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chi nhánh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataBranch &&
              dataBranch?.find(
                (i: any) =>
                  String(i?.orgId) === String(dataOrderDetail?.fromBranchId),
              )?.orgCode}{" "}
            - {dataOrderDetail.fromBranchName}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Phường/Xã
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusCommuneName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa điểm làm việc
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.fromBranchAddress}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa chỉ cụ thể
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusAddress}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Kho
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.fromInvCode
              ? `${dataOrderDetail.fromInvCode} - ${
                  dataOrderDetail.fromInvName || ""
                }`
              : dataOrderDetail.fromInvName || ""}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Người nhận
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.toEmpName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Họ & Tên
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createName
              ? dataOrderDetail?.createName +
                " - " +
                dataOrderDetail?.createCode
              : ""}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Số điện thoại
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusTelephone}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chức danh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createRoleName || ""}
          </Text>
        ),
      },
      { content: null },
      { content: null },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Giao hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {" "}
            {getDeliveryText(dataOrderDetail?.delivery || "")}
          </Text>
        ),
      },
      { content: null },
      { content: null },
    ],
    isLocked || isEdit
      ? [
          {
            content: (
              <Text
                fw={700}
                w={"100px"}
                size="sm"
                style={{ whiteSpace: "normal" }}
                truncate
              >
                Diễn giải chứng từ gốc
              </Text>
            ),
          },
          {
            content: (
              <Text size="sm" w={"500px"}>
                {dataOutWard?.sourceDescription}
              </Text>
            ),
            colSpan: 3,
          },
        ]
      : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Lý do YCDC
          </Text>
        ),
      },
      {
        content: <Text size="sm">{dataOrderDetail?.transferReason || ""}</Text>,
        colSpan: 2,
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Ghi chú
          </Text>
        ),
      },
      {
        content: (
          <TextInput
            error={
              dataOutWard?.description && dataOutWard.description.length > 300
                ? "Ghi chú không được vượt quá 300 kí tự!"
                : null
            }
            className={classesButton.text_input}
            value={dataOutWard?.description ?? ""}
            onChange={(e) =>
              handleChangeValueInput(e.target.value, "description")
            }
            disabled={isLocked}
            placeholder={isLocked ? "" : "Vui lòng nhập"}
          />
        ),
        colSpan: 3,
      },
    ],
  ];

  return (
    <RenderTable
      headers={headers}
      rows={rows.filter((item) => item.length !== 0)}
    />
  );
};

type RequestVendorReturnOutWardProps = {
  dataSearchSourceCodeOption?: any[];
  dataPosition?: ComboboxItem[];
  dataOutWard: tblInventoryTransaction;
  dataOrderDetail: any;
  handleChangeValueInput: (value: string | boolean | null, key: string) => void;
  setSourceCode?: (value: any) => void;
  handleKeyDownSourceCode?: (e: any) => void;
  sourceCode?: any;
  isSave?: boolean;
  setSearchSourceCode?: (newValue: React.SetStateAction<string>) => void;
  isEdit?: boolean;
  isLocked?: boolean;
  haveSourceCode?: boolean;
  action: string;
  dataBranch: any;
  updatedDataInventoryTransactionType?: ComboboxItem[];
};

export default RequestVendorReturnOutWard;
